module.exports = __webpack_public_path__ + "static/media/developer-picturemark-d.1101a429.svg";